export default function initSidebarScrollSpy() {
  initScrollSpy();
}

function initScrollSpy() {
  const navLinks = document.querySelectorAll('.l-sidebar__nav-list a');
  if (navLinks.length === 0) return;

  // 監視対象のセクションを収集
  const sections = [];
  navLinks.forEach(link => {
    const href = link.getAttribute('href');
    if (href && href.includes('#')) {
      const id = href.split('#')[1];
      const section = document.getElementById(id);
      if (section) {
        sections.push(section);
      }
    }
  });

  if (sections.length === 0) return;

  const observerOptions = {
    root: null,
    rootMargin: '-50% 0px -50% 0px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.target instanceof HTMLElement) {
        const id = entry.target.id;
        navLinks.forEach(link => {
          const href = link.getAttribute('href');
          // 完全一致またはハッシュ部分の一致を確認
          if (href === `#${id}` || href.endsWith(`#${id}`)) {
            link.classList.add('is-active');
          } else {
            link.classList.remove('is-active');
          }
        });
      }
    });
  }, observerOptions);

  sections.forEach(section => {
    observer.observe(section);
  });
}
